import { Dispatch, useReducer } from 'react';

import { standardizeResponseObject, ApiResponse } from './libs';

export type State<Data> = {
  data: ApiResponse<Data> | null;
  error: Error | null;
  loading: boolean;
  called: boolean;
};

type Request = { type: 'REQUEST' };
type CacheHit<Data> = { type: 'CACHE_HIT'; payload: Data };
type Success<Data> = { type: 'SUCCESS'; payload: Data | null };
type Failure = { type: 'FAILURE'; payload: Error };
export type Action<Data> = Request | Success<Data> | CacheHit<Data> | Failure;

export function useFetchReducer<Data = unknown>(
  initialValue?: Data,
): [State<Data>, Dispatch<Action<Data>>] {
  function reducer(state: State<Data>, action: Action<Data>): State<Data> {
    switch (action.type) {
      case 'REQUEST':
        return {
          ...state,
          called: true,
          loading: true,
        };
      case 'SUCCESS':
        return {
          ...state,
          loading: false,
          data: standardizeResponseObject(action.payload),
        };
      case 'CACHE_HIT':
        return {
          ...state,
          data: standardizeResponseObject(action.payload),
        };
      case 'FAILURE':
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  }

  return useReducer(reducer, initialValue, (data) => {
    return {
      loading: false,
      called: false,
      data: data ? standardizeResponseObject(data) : null,
      error: null,
    };
  });
}
